import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  clearSelectedVisitPartAction,
  clearVisitPartsActions,
  getVisitPartsActions,
} from '../../../redux/actions/visitPartsActions';

const useFetchVisitParts = (visitId, vin) => {
  const dispatch = useDispatch();
  const visitParts = useSelector((state) => state.visitParts?.visitParts);
  const loading = useSelector((state) => state.visitParts?.loading);

  const fetchVisitParts = useCallback(async () => {
    await dispatch(getVisitPartsActions(visitId, vin));
  }, [visitId, vin, dispatch]);

  useEffect(() => {
    fetchVisitParts();
  }, [fetchVisitParts]);

  useEffect(() => {
    return () => {
      dispatch(clearVisitPartsActions());
      dispatch(clearSelectedVisitPartAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchVisitParts();
  };

  return { loading, visitParts, refresh };
};

export default useFetchVisitParts;
